import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import InfiniteScroll from "react-infinite-scroll-component"

import Loader from "../../../../../../components/Loader"

import { saleEventOptions } from "../sortOptions"

import AdvertisementList from "../../../AdvertisementList"
import ListingCard from "../../../ListingCard"
import { getBaseUrl } from "../../../../reducers"
import { getTopSaleEvents } from "../../../../requesters"

export default function CustomCouponList({
  sortOptionSaleValue,
  customList,
  isReady,
  filterOptions: {
    storeIds,
    brandIds,
    departmentIds,
    categoryIds,
    paymentMethods,
    startRange
  },
  sortColumn, sortDirection
}) {
  const [saleEventIds, setSaleEventIds] = useState([])
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(true)
  const [column, setColumn] = useState("fixed_global_score")
  const [direction, setDirection] = useState("desc")

  const baseUrl = useSelector(getBaseUrl)
  const params = {
    page,
    per_page: 50,
    by_brands: brandIds,
    by_stores: storeIds,
    by_departments: departmentIds,
    by_categories: categoryIds,
    by_payment_methods: paymentMethods,
    by_date_range: startRange,
    "by_order[column]": column,
    "by_order[direction]": direction
  }

  useEffect(() => {
    setPage(0)
    setSaleEventIds([])
  }, [
    storeIds, brandIds,
    departmentIds, categoryIds,
    paymentMethods,
    column, direction,
    sortColumn, sortDirection
  ])

  useEffect(() => {
    async function fetchCustomSaleEvents() {
      setLoading(true)
      const { response } = await getTopSaleEvents(baseUrl, params)
      setSaleEventIds([...saleEventIds, ...response.ids])
      if (response.ids) setLoading(false)
    }

    if (customList && page > 0 && isReady) fetchCustomSaleEvents()
    if (page === 0) setPage(1)
  }, [page, isReady])

  useEffect(() => {
    const option = saleEventOptions.values.find(value => value.key === parseInt(sortOptionSaleValue, 10))
    if (option) {
      setColumn(option.value)
      setDirection(option.order)
    }
  }, [sortOptionSaleValue])

  return (
    <Fragment>
      <br />
      {
        // Show when there is no data to see
        (!loading && saleEventIds.length === 0)
        ? <p>No data to see here</p>
        : (
          <>
            {/* <h3>{customList.attributes.title}</h3>
            <p>{customList.attributes.subtitle}</p> */}
            <AdvertisementList location={`ranking-${customList.attributes.resourceType}-top`} position="middle" page="ranking" list={customList.attributes.resourceType} />
            <InfiniteScroll
              className="row listing-grid"
              dataLength={saleEventIds.length} // This is important field to render the next data
              next={() => setPage(page + 1)}
              hasMore
              loader={<div className="listing-card col-12"><Loader isLoading={loading} /></div>}
              endMessage={(
                <p style={{ textAlign: "center" }}>
                  <b>Yay! You have seen it all</b>
                </p>
              )}>
              {_.map(saleEventIds, (saleEventId, index) => (
                <ListingCard type="saleEvent" id={saleEventId} wrapperClass="col-sm-6 col-lg-4" position={index + 1} key={`sale-event-${saleEventId}`} currentSection='SaleEventList' sectionPosition={1} />
              ))}
            </InfiniteScroll>
          </>
        )
      }
    </Fragment>
  )
}
